// This file is CommonJS so that the script that uses it does not need Babel

module.exports = [
  {
    locale: 'en_us',
    parentLocale: 'en',
    displayName: 'English (US)',
  },
  {
    locale: 'es',
    displayName: 'Spanish',
  },
  {
    locale: 'fr',
    displayName: 'French',
  },
  {
    locale: 'de',
    displayName: 'German',
  },
  {
    locale: 'pt',
    displayName: 'Portuguese',
  },
  {
    locale: 'ar',
    rtl: true,
    displayName: 'Arabic',
  },
  {
    locale: 'he',
    rtl: true,
    displayName: 'Hebrew',
  },
  {
    locale: 'af',
    name: 'Afrikaans',
    displayName: 'Afrikaans',
  },
  {
    locale: 'bg',
    name: 'Bulgarian',
    displayName: 'Български',
  },
  {
    locale: 'bs',
    name: 'Bosnian',
    displayName: 'Bosanski',
  },
  {
    locale: 'ca',
    name: 'Catalan',
    displayName: 'Català',
  },
  {
    locale: 'cs',
    name: 'Czech',
    displayName: 'Čeština',
  },
  {
    locale: 'da',
    name: 'Danish',
    displayName: 'Dansk',
  },
  {
    locale: 'nl',
    name: 'Dutch',
    displayName: 'Nederlands',
  },
  {
    locale: 'el',
    name: 'Greek',
    displayName: 'Ελληνικά',
  },
  {
    locale: 'et',
    name: 'Estonian',
    displayName: 'Eesti',
  },
  {
    locale: 'fi',
    name: 'Finnish',
    displayName: 'Suomi',
  },
  {
    locale: 'fil',
    name: 'Filipino',
    displayName: 'Filipino',
  },
  {
    locale: 'hi',
    name: 'Hindi',
    displayName: 'हिंदी',
  },
  {
    locale: 'hr',
    name: 'Croatian',
    displayName: 'Hrvatski',
  },
  {
    locale: 'hu',
    name: 'Hungarian',
    displayName: 'Magyar',
  },
  {
    locale: 'id',
    name: 'Indonesian',
    displayName: 'Bahasa Indonesia',
  },
  {
    locale: 'is',
    name: 'Icelandic',
    displayName: 'Íslenska',
  },
  {
    locale: 'it',
    name: 'Italian',
    displayName: 'Italiano',
  },
  {
    locale: 'ja',
    name: 'Japanese',
    displayName: '日本語',
  },
  {
    locale: 'ka',
    name: 'Georgian',
    displayName: 'ქართული',
  },
  {
    locale: 'ko',
    name: 'Korean',
    displayName: '한국어',
  },
  {
    locale: 'lt',
    name: 'Lithuanian',
    displayName: 'Lietuvių',
  },
  {
    locale: 'lv',
    name: 'Latvian',
    displayName: 'Latviešu',
  },
  {
    locale: 'no',
    name: 'Norwegian',
    displayName: 'Norsk',
  },
  {
    locale: 'pl',
    name: 'Polish',
    displayName: 'Polski',
  },
  {
    locale: 'pt_br',
    parentLocale: 'pt',
    name: 'Portuguese (BR)',
    displayName: 'Português (BR)',
  },
  {
    locale: 'ro',
    name: 'Romanian',
    displayName: 'Română',
  },
  {
    locale: 'ru',
    name: 'Russian',
    displayName: 'Русский',
  },
  {
    locale: 'sk',
    name: 'Slovakian',
    displayName: 'Slovenčina',
  },
  {
    locale: 'sl',
    name: 'Slovenian',
    displayName: 'Slovenščina',
  },
  {
    locale: 'sq',
    name: 'Albanian',
    displayName: 'Shqip',
  },
  {
    locale: 'sr',
    name: 'Serbian',
    displayName: 'Srpski',
  },
  {
    locale: 'sr_me',
    parentLocale: 'sr',
    name: 'Serbian (Montenegro)',
    displayName: 'Crnogorski',
  },
  {
    locale: 'sv',
    name: 'Swedish',
    displayName: 'Svenska',
  },
  {
    locale: 'sw',
    name: 'Swahili',
    displayName: 'Kiswahili',
  },
  {
    locale: 'th',
    name: 'Thai',
    displayName: 'ภาษาไทย',
  },
  {
    locale: 'tr',
    name: 'Turkish',
    displayName: 'Türkçe',
  },
  {
    locale: 'tw',
    parentLocale: 'ak',
    name: 'Twi',
    displayName: 'Twi',
    skipAutoTranslate: true,
  },
  {
    locale: 'uk',
    name: 'Ukrainian',
    displayName: 'Українська',
  },
  {
    locale: 'vi',
    name: 'Vietnamese',
    displayName: 'Tiếng Việt',
  },
  {
    locale: 'zh_cn',
    parentLocale: 'zh',
    name: 'Simplified Chinese',
    displayName: '中文 (简体)',
  },
  {
    locale: 'zh_tw',
    parentLocale: 'zh',
    name: 'Traditional Chinese',
    displayName: '中文 (香港)',
  },
];

// Unused but included for thoroughness
// eslint-disable-next-line no-unused-vars
const notSupported = [
  {
    locale: 'en_ca',
    name: 'English (CA)',
    displayName: 'English (CA)',
  },
  {
    locale: 'en_gb',
    name: 'English (UK)',
    displayName: 'English (UK)',
  },
  {
    locale: 'es_es',
    name: 'Spanish (Spain)',
    displayName: 'Español (España)',
  },
  {
    locale: 'fr_ca',
    name: 'French (CA)',
    displayName: 'Français (CA)',
  },
];
